import React, { useContext, useState } from 'react'
import { SearchIcon, SearchIconWhite } from '../../../assets/images'
import { ThemeContext } from '../../../Context/ThemeContext'

const InfoComponent = ({ headerName, infoArr }) => {

    const [search, setSearch] = useState("")
    const { isDarkTheme } = useContext(ThemeContext)

    const tempInfoArr = infoArr?.filter((item) => item?.Value?.toLowerCase().includes(search.toLowerCase()))   

    return (
        <div className="SiteLeftContainer ml-2 mr-2"
        >
            <div className="infoFilterHeader">
                <p>{headerName}</p>
            </div>
            <div className="m-2 HeaderSiteList">
                <input
                    id="Search_txt_site"
                    className="SearchViewInput1"
                    type="text"
                    placeholder={`Search ${headerName}`}
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                />
                <div className="SearchTextDivConfigTool">
                    {isDarkTheme ? (
                        <img
                            className="EyeIcon"
                            src={SearchIcon}
                            alt="search icon"
                        />
                    ) : (
                        <img
                            className="EyeIcon"
                            src={SearchIconWhite}
                            alt="search icon"
                            height="15"
                        />
                    )}
                </div>
            </div>
            <div className="SaveFilterInfoList">
                {infoArr &&
                    tempInfoArr?.length > 0
                    ? (
                        <div>{
                            tempInfoArr.map((item) => (
                                <p className="ListofText">
                                    {item.Value}
                                </p>
                            ))
                        }

                        </div>
                    ) : (
                        <div className="no-data-found">
                            <p>No {headerName} Found</p>
                        </div>
                    )}
                {!tempInfoArr && (
                    <div className="no-data-found">
                        No {headerName} Available
                    </div>
                )}
            </div>
        </div>
    )
}

export default InfoComponent
